<template>
  <span>{{ formatedText }}</span>
</template>
<script>
import { format } from "d3-format";
export default {
  props: {
    text: {
      type: Number,
    },
    currencyFormat: {
      type: String,
    },
    appendText: {
      type: String,
    },
    drawDownOptions: {
      type: Array,
    },
  },

  computed: {
    formatedText() {
      if (this.appendText && this.appendText != "") {
        return this.text + this.appendText;
      } else if (this.currencyFormat && this.currencyFormat != "") {
        return format(this.currencyFormat)(this.text);
      } else if (this.drawDownOptions && this.drawDownOptions.length > 0) {
        let currentOption = this.drawDownOptions.filter(
          (sr) => sr.value == this.text
        );
        if (currentOption && currentOption.length > 0) {
          return currentOption[0].text;
        } else {
          return this.text;
        }
      } else {
        return this.text;
      }
    },
  },

  async created() {},
};
</script>
